import { format } from 'date-fns';
import { useMapStore } from '@/stores/mapStore';

export default function CatalystDetailModal({ catalyst, onClose }) {
  const openGiveModal = useMapStore((s) => s.openGiveModal);

  const {
    id,
    title,
    event_date,
    event_type,
    organization,
    region,
    impact_count,
    lives_affected,
    narrative,
  } = catalyst;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-fade-in"
      onClick={onClose}
    >
      <div
        className="w-full max-w-md rounded-2xl border border-neutral-200 bg-document shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between border-b border-neutral-200 px-5 py-4">
          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-[#003cc5]">
              Event #{id}
            </p>
            <h2 className="text-base font-semibold text-ink">{title}</h2>
          </div>
          <button
            onClick={onClose}
            className="rounded-lg p-1.5 text-neutral-500 transition hover:bg-parchment hover:text-ink"
            aria-label="Close"
          >
            <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Body */}
        <div className="px-5 py-4 space-y-4">
          {/* Stats row */}
          <div className="flex flex-wrap gap-3">
            {impact_count > 0 && (
              <div className="flex items-center gap-1.5 rounded-full bg-red-50 border border-red-200 px-3 py-1 text-xs font-medium text-[#003cc5]">
                <svg className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                {impact_count.toLocaleString()} impacted
              </div>
            )}
            {lives_affected > 0 && (
              <div className="flex items-center gap-1.5 rounded-full bg-neutral-100 border border-neutral-200 px-3 py-1 text-xs font-medium text-neutral-600">
                {lives_affected.toLocaleString()} lives affected
              </div>
            )}
          </div>

          {/* Meta */}
          <dl className="grid grid-cols-2 gap-x-4 gap-y-2 text-xs">
            {event_date && (
              <>
                <dt className="text-neutral-400">Date</dt>
                <dd className="text-ink">{format(new Date(event_date), 'MMMM d, yyyy')}</dd>
              </>
            )}
            {event_type && (
              <>
                <dt className="text-neutral-400">Type</dt>
                <dd className="text-ink">{event_type}</dd>
              </>
            )}
            {region && (
              <>
                <dt className="text-neutral-400">Region</dt>
                <dd className="text-ink">{region}</dd>
              </>
            )}
            {organization && (
              <>
                <dt className="text-neutral-400">Organisation</dt>
                <dd className="text-ink">{organization}</dd>
              </>
            )}
          </dl>

          {/* Narrative */}
          {narrative && (
            <div className="rounded-lg border border-neutral-200 bg-parchment px-4 py-3">
              <p className="mb-1 text-xs font-medium text-neutral-400 uppercase tracking-wider">Narrative</p>
              <p className="text-sm leading-relaxed text-ink">{narrative}</p>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="border-t border-neutral-200 px-5 py-4">
          <button
            onClick={() => {
              onClose();
              openGiveModal({ catalystId: id, regionName: region });
            }}
            className="w-full rounded-xl bg-[#003cc5] py-2.5 text-sm font-semibold text-white transition hover:bg-[#0036b1] active:scale-95"
          >
            Give Now — Support this Movement
          </button>
        </div>
      </div>
    </div>
  );
}
